import { graphql } from '../../gql';

export const ROLE_V2_SELECTION_LIST_QUERY = graphql(`
  query RoleV2SelectionList {
    selectionList {
      job_category {
        id
        shortName
        longName
        label: longName
        topCleanedTitles
        topRawTitles
      }
      role_k50 {
        id
        shortName
        longName
        label: longName
        topCleanedTitles
        topRawTitles
        job_category: roleK7
      }
      role_k150 {
        id
        shortName
        longName
        label: longName
        topCleanedTitles
        topRawTitles
        job_category: roleK7
        role_k50: roleK50
      }
      role_k300 {
        id
        shortName
        longName
        label: longName
        topCleanedTitles
        topRawTitles
        job_category: roleK7
        role_k50: roleK50
        role_k150: roleK150
      }
      role_k500 {
        id
        shortName
        longName: shortName
        label: shortName
        topCleanedTitles
        topRawTitles
        job_category: roleK7
        role_k50: roleK50
        role_k150: roleK150
        role_k300: roleK300
      }
      role_k1000 {
        id
        shortName
        longName
        label: longName
        topCleanedTitles
        topRawTitles
        job_category: roleK7
        role_k50: roleK50
        role_k150: roleK150
        role_k300: roleK300
        role_k500: roleK500
      }
      role_k1250 {
        id
        shortName
        longName
        label: longName
        topCleanedTitles
        topRawTitles
        job_category: roleK7
        role_k50: roleK50
        role_k150: roleK150
        role_k300: roleK300
        role_k500: roleK500
        role_k1000: roleK1000
      }
      role_k1500 {
        id
        shortName
        longName
        label: longName
        topCleanedTitles
        topRawTitles
        job_category: roleK7
        role_k50: roleK50
        role_k150: roleK150
        role_k300: roleK300
        role_k500: roleK500
        role_k1000: roleK1000
        role_k1250: roleK1250
      }
    }
  }
`);
